import { MouseEvent } from 'react'
import { Avatar, Typography, Card, Box, Stack, Button } from '@mui/material'
import {
    CardItem,
    TypDescription,
    CardImageMobile,
} from './style'
import { ViewCounter } from '../../../ui-kit/ViewCounter'
import { useNavigate } from 'react-router'
import { routesProfile } from '../../../../consts'
import { formatNumber } from '../../../../common/FormatNumber'
import type { IGrowthToolListItem } from '../../../../api/types/growthTools'
import { resolveGrowthToolCommentsTotal } from '../../../../api/types/growthTools'
import { GrowthToolLikeControl } from '../../../GrowthTool/GrowthToolLikeControl'
import { IconComments } from '../../../../icons/IconComments'
import { useGrowthToolEngagement } from '../../../../hooks/useGrowthToolEngagement'
import {
    getUserInitialsFromDisplayName,
    resolveUserAvatarUrl,
    resolveUserDisplayName,
} from '../../../../utils/deletedUserDisplay'

interface GrowthToolItemProps {
    growthTool: IGrowthToolListItem
}

export const MobileCard = ({ growthTool }: GrowthToolItemProps) => {
    const navigate = useNavigate();
    const {
        isAuthor,
        isFavorite,
        favoritesCount,
        isLiked,
        likesCount,
        toggleFavorite,
        toggleLike,
        isFavoriteLoading,
        isLikeLoading,
    } = useGrowthToolEngagement({ growthTool })
    const commentsCount = resolveGrowthToolCommentsTotal(growthTool.counters.comments)
    const authorName = resolveUserDisplayName(growthTool.author)
    const pathKey = growthTool.slug || String(growthTool.id)

    const navigateToGrowthTool = () => {
        navigate(`/${routesProfile.GROWTHTOOLS.path}/${pathKey}`)
    }
    const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        navigate(`/${routesProfile.GROWTHTOOLS.path}/${growthTool.id}/edit`)
    };
    const handleToggleFavorite = async (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        await toggleFavorite()
    }
    return (
        <Card variant='primaryAdaptiveCard' sx={CardItem} onClick={navigateToGrowthTool}>
            <Stack direction='column' py={1.5} width="100%">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant='h3' flex={1} minWidth={0} noWrap>{growthTool.title}</Typography>
                    {isAuthor ? (
                        <Button variant="follow" sx={{ ml: 1 }} onClick={handleEdit}>Редактировать</Button>
                    ) : (
                        <Button
                            variant="follow"
                            sx={{ ml: 1 }}
                            disabled={isFavoriteLoading}
                            onClick={handleToggleFavorite}
                        >
                            {isFavorite ? 'В избранном' : 'В избранное'}
                        </Button>
                    )}
                </Stack>
                <Stack direction="row" alignItems="center" gap={1} minWidth={0} mb={1}>
                    <Avatar src={resolveUserAvatarUrl(growthTool.author)} sx={{ width: 24, height: 24 }}>
                        {getUserInitialsFromDisplayName(authorName)}
                    </Avatar>
                    <Typography variant="black-14-light" noWrap>{authorName}</Typography>
                </Stack>
                {growthTool.image ? (
                    <Box component="img" src={growthTool.image} alt="Image" sx={CardImageMobile} />
                ) : null}
                <Typography variant='body1' sx={TypDescription}>{growthTool.description}</Typography>
                <Stack direction="column" gap={1}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1.5} flexWrap="wrap">
                        <Typography variant="black-14-medium">В избранном: {formatNumber(favoritesCount)}</Typography>
                        <ViewCounter count={growthTool.counters.views} />
                    </Stack>
                    <Stack direction="row" alignItems="center" gap={2}>
                        <Box onClick={(e) => e.stopPropagation()}>
                            <GrowthToolLikeControl
                                growthToolId={growthTool.id}
                                isLiked={isLiked}
                                likesCount={likesCount}
                                likesPreview={growthTool.likes_preview}
                                onToggleLike={toggleLike}
                                loading={isLikeLoading}
                                compact
                            />
                        </Box>
                        <Stack direction="row" alignItems="center" gap={0.5}>
                            <IconComments fontSize="small" />
                            <Typography variant="black-14-medium">{formatNumber(commentsCount)}</Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Card>
    )
}
